import { gql } from '@apollo/client';

export default gql`
  mutation CancelHotelProduct($bookingReference: String!, $fee: Float!, $marginFee: Float, $itemRef: String!, $skipConfirmation: Boolean) {
    cancelHotelProduct(
      bookingReference: $bookingReference
      itemRef: $itemRef
      fee: $fee
      marginFee: $marginFee
      skipConfirmation: $skipConfirmation
    ) {
      reference
      paymentsRefundBalance
    }
  }
`;
